export const GET_MUSICAL_FAMILIES = "GET_MUSICAL_FAMILIES";
export const GET_MUSICAL_FAMILY_BY_ID = "GET_MUSICAL_FAMILY_BY_ID";
export const UPDATE_MUSICAL_FAMILY = "UPDATE_MUSICAL_FAMILY";
export const DELETE_MUSICAL_FAMILY = "DELETE_MUSICAL_FAMILY";
export const CREATE_MUSICAL_FAMILY = "CREATE_MUSICAL_FAMILY";
export const GET_PROGRAMS_BY_MUSICAL_FAMILY = "GET_PROGRAMS_BY_MUSICAL_FAMILY";
